// DashboardEmpleado.jsx
import  React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import api from "../../utils/Api";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Clock, AlertCircle } from "lucide-react";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend);

export default function DashboardEmpleado() {
  const { token, loading, user } = useContext(AuthContext);

  const [fichajesHoy, setFichajesHoy] = useState(0);
  const [graficoFichajes, setGraficoFichajes] = useState({ labels: [], data: [] });
  const [incidencias, setIncidencias] = useState([]);
  const [filterEstado, setFilterEstado] = useState("");

  const loadData = async () => {
    if (!token) return;

    try {
      const hoy = new Date().toISOString().slice(0, 10);

      // Fichajes del usuario
      const fichajesRes = await api.get("/fichajes/mios", {
        headers: { Authorization: `Bearer ${token}` },
        params: { fecha_inicio: hoy },
      });
      setFichajesHoy(fichajesRes.data.length);

      // Incidencias propias
      const incidenciasRes = await api.get("/incidencias/mias", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setIncidencias(incidenciasRes.data);

      // Gráfico últimos 7 días
      const dias = Array.from({ length: 7 }).map((_, i) => {
        const d = new Date();
        d.setDate(d.getDate() - i);
        return d.toISOString().slice(0, 10);
      }).reverse();

      const fichajesPorDia = dias.map(
        (dia) => fichajesRes.data.filter((f) => f.fecha === dia).length
      );

      setGraficoFichajes({ labels: dias, data: fichajesPorDia });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => { loadData(); }, [token]);

  if (loading) return <p className="text-center mt-5">Cargando...</p>;

  const incidenciasFiltradas = filterEstado ? incidencias.filter((i) => i.estado === filterEstado) : incidencias;

  return (
    <div className="container my-4">
      <h1 className="mb-4" style={{ color: "#2C2C2C", fontSize: "1.5rem" }}>Dashboard</h1>

      {/* Cards resumidas */}
      <div className="row g-3 mb-4">
        <div className="col-12 col-md-6">
          <div className="card shadow-sm rounded-4 p-3 text-center" style={{ background: "#FF7A00", color: "white" }}>
            <Clock size={28} className="mb-2" />
            <h6 style={{ fontSize: "0.9rem" }}>Fichajes hoy</h6>
            <p className="h4 mb-1" style={{ fontWeight: 600 }}>{fichajesHoy}</p>
          </div>
        </div>
        <div className="col-12 col-md-6">
          <div className="card shadow-sm rounded-4 p-3 text-center" style={{ background: "#FFC107", color: "#2C2C2C" }}>
            <AlertCircle size={28} className="mb-2" />
            <h6 style={{ fontSize: "0.9rem" }}>Incidencias pendientes</h6>
            <p className="h4 mb-1" style={{ fontWeight: 600 }}>
              {incidencias.filter((i) => i.estado === "pendiente").length}
            </p>
          </div>
        </div>
      </div>

      {/* Gráfico fichajes */}
      <div className="card shadow-sm rounded-4 p-3 mb-4" style={{ height: "240px" }}>
        <h6>Fichajes últimos 7 días</h6>
        <Line
          data={{
            labels: graficoFichajes.labels,
            datasets: [{
              label: "Fichajes",
              data: graficoFichajes.data,
              borderColor: "#FF7A00",
              backgroundColor: "rgba(255,122,0,0.2)",
              fill: true,
              tension: 0.4,
            }],
          }}
          options={{ responsive: true, plugins: { legend: { display: false } }, maintainAspectRatio: false }}
        />
      </div>

      {/* Incidencias */}
      <div className="card shadow-sm rounded-4 p-3">
        <h6 className="mb-3">Mis últimas incidencias</h6>
        <div className="mb-3 d-flex gap-2 align-items-center flex-wrap">
          <label className="fw-bold" style={{ fontSize: "0.85rem" }}>Filtrar por estado:</label>
          <select className="form-select w-auto" value={filterEstado} onChange={(e) => setFilterEstado(e.target.value)}>
            <option value="">Todos</option>
            <option value="pendiente">Pendiente</option>
            <option value="resuelta">Resuelta</option>
            <option value="rechazada">Rechazada</option>
          </select>
        </div>

        {incidenciasFiltradas.length > 0 ? (
          <div className="row g-3">
            {incidenciasFiltradas.map((i) => (
              <div key={i.id} className="col-12 col-md-6 col-lg-4">
                <div className="card shadow-sm rounded-4 p-3 h-100 hover-shadow" style={{ transition: "all 0.3s", cursor: "pointer" }}>
                  <div className="d-flex justify-content-between mb-2">
                    <strong style={{ fontSize: "0.85rem" }}>{i.tipo.toUpperCase()}</strong>
                    <span className={`badge ${i.estado === "pendiente" ? "bg-warning text-dark" : i.estado === "resuelta" ? "bg-success" : "bg-danger"}`} style={{ fontSize: "0.75rem" }}>
                      {i.estado.toUpperCase()}
                    </span>
                  </div>
                  <p className="mb-1" style={{ fontSize: "0.85rem" }}>{i.comentario}</p>
                  <p className="mb-0 text-muted" style={{ fontSize: "0.75rem" }}>{new Date(i.fecha_hora).toLocaleString()}</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center text-muted mt-2" style={{ fontSize: "0.85rem" }}>No tienes incidencias</p>
        )}
      </div>
    </div>
  );
}
